<template>
    <div class="cc-addresses">
        <div class="cc-addresses__delivery-address">
            <delivery-address/>
        </div>
        <div class="cc-addresses__different-invoice-address" v-if="!pickupInStore">
            <div class="cc-form-input">
                <input id="user.differentInvoiceAddress" type="checkbox" name="user.differentInvoiceAddress" class="cc-input cc-input--checkbox" :checked="user.differentInvoiceAddress" @change="toggleDifferentInvoiceAddress">
                <label for="user.differentInvoiceAddress" class="cc-label cc-label--checkbox cc-label--important-checkbox">{{ translations['Different invoice address'] }}</label>
            </div>
        </div>
        <div class="cc-addresses__invoice-address" v-if="!pickupInStore && user.differentInvoiceAddress">
            <invoice-address/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import DeliveryAddress from "./DeliveryAddress";
    import InvoiceAddress from "./InvoiceAddress";

    export default {
        components: {
            DeliveryAddress,
            InvoiceAddress,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                currentCarrier: state => state.currentCarrier,
                user: state => state.user,
            }),
            pickupInStore: function() {
                return this.currentCarrier ? this.currentCarrier.pickupInStore : false;
            },
        },
        methods: {
            toggleDifferentInvoiceAddress: function (event) {
                this.$store.commit('SET_USER_DIFFERENT_INVOICE_ADDRESS', event.target.checked);
            },
        },
        name: 'Addresses',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/addresses";
</style>
